import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css'; // css file for the react-bootstrap library
import 'react-toastify/dist/ReactToastify.css'; // css file for the react-toastify library
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { StoreProvider } from './Store';
import './i18n/i18n';
import { dbPromise } from './indexedDB';
import MaintenanceGate from './components/general/MaintenanceGate';

async function initializeApp() {
  try {
    await dbPromise;
    console.log('IndexedDB initialized successfully.');

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <MaintenanceGate>
        {/* shows the maintenance screen instead of the app while the backend is in maintenance mode (components/general/MaintenanceGate.js) */}
        <StoreProvider>
          {/* StoreProvider is a wrapper of the react application and passes global props to its children (created in Store.js) */}
          <PayPalScriptProvider deferLoading={true}>
            {/* a higher order component, that wraps the whole app and allows the web application to use the provided APIs to implement various PayPal-related features. deferLoading prop tells the component to delay the loading of the SDK until it is actually needed */}
            <App />
          </PayPalScriptProvider>
        </StoreProvider>
      </MaintenanceGate>
    );

    reportWebVitals();
  } catch (error) {
    console.error('Failed to initialize IndexedDB:', error);
  }
}

initializeApp(); // Call the initialization function
